import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import IconList from '@/components/icons/icon-list.vue';
import IconMap from '@/components/icons/icon-map.vue';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#007DB6',
        secondary: '#b0bec5',
        accent: '#5ba33c', //'#8c9eff',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        anchor: '#007DB6'
      }
    }
  },
  icons: {
    values: {
      nexlist: {
        component: IconList
      },
      nexmap: {
        component: IconMap
      }
    }
  }
});
